import { render, staticRenderFns } from "./OJIter.vue?vue&type=template&id=80c7bcfc&scoped=true&"
import script from "./OJIter.vue?vue&type=script&lang=ts&"
export * from "./OJIter.vue?vue&type=script&lang=ts&"
import style0 from "./OJIter.vue?vue&type=style&index=0&id=80c7bcfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c7bcfc",
  null
  
)

export default component.exports